import React, { useState } from "react";
import { SegmentedControl } from "../../ui";
import PdfLivePreview from "../PdfLivePreview";

/**
 * Settings → Invoices → the preview: the REAL invoice PDF for a sample ₹10,000
 * payment (`POST /invoice-settings/sample`, nothing saved), the same renderer
 * every fee invoice uses.
 *
 * Props:
 *   body        the settings exactly as Save would send them, plus the GSTIN to show
 *   refreshKey  changes when something outside the form changes the invoice (the signature)
 */
export default function InvoicePreview({ body, refreshKey }) {
  const [buyer, setBuyer] = useState("same");
  const gstOn = Boolean(body?.gst?.enabled);

  return (
    <PdfLivePreview
      url="/invoice-settings/sample"
      body={{ ...body, sample: { otherState: gstOn && buyer === "other" } }}
      refreshKey={refreshKey}
      heading="Preview — the real PDF, for a sample payment"
      label="Sample invoice preview"
      fileName="sample-invoice.pdf"
      footnote="The same document your students download, print and receive by email."
      toolbar={gstOn && (
        <SegmentedControl
          label="Preview the student as"
          size="xs"
          value={buyer}
          onChange={setBuyer}
          options={[
            { value: "same", label: "In your state" },
            { value: "other", label: "In another state" },
          ]}
        />
      )}
    />
  );
}
